"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppTrackEvent = void 0;
var AppTrackEvent;
(function (AppTrackEvent) {
    AppTrackEvent["AppDetailsOpened"] = "AppDetailsOpened";
    AppTrackEvent["AppPageOpened"] = "AppPageOpened";
})(AppTrackEvent || (exports.AppTrackEvent = AppTrackEvent = {}));
